// extracted by mini-css-extract-plugin
export default {"simpleContainer":"SectionJoinStories_simpleContainer__tjHb6","container":"SectionJoinStories_container__5Gt9R","widget":"SectionJoinStories_widget__lenjW"};